/** 2025-12-03 */
/**
 *  { user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; }
 *  ^ must be add to parent style to prevent drag select text, or interrupting scroll drag issue
 */

import './styles/ScrollBar.scss';
import { useState, useRef, useEffect, ReactElement } from 'react';
import { DebugLogger as dlog } from './Logger';

interface Props {
    targetRef: any,
    className?: string
}

//classes
class CursorPosition {
    public posX: number = -1;
    public posY: number = -1;

    constructor(posX: number, posY: number) {
        this.posX = posX;
        this.posY = posY;
    }
}

const ScrollBar: React.FC<Props> = ({ targetRef, className }) => {
    //states
    const [scrolledPercentile, SetScrolledPercentile] = useState<number>(0); // 0 - 100
    //refs - elems
    const cursorSpaceRef = useRef<HTMLDivElement>(null);
    //refs - vars
    const previousCursorPosRef = useRef<CursorPosition | null>(null);
    const updateScrollPercentileAnimRef = useRef<any>(null);
    const scrolledPercentileRef = useRef<number>(scrolledPercentile);
    //refs - listener actions
    const OnMouseMoveRef = useRef<any>((e: any) => {
        if(previousCursorPosRef.current && cursorSpaceRef.current) {
            const maxHeight = cursorSpaceRef.current.clientHeight;
            const movedY = e.clientY - previousCursorPosRef.current.posY;
            scrolledPercentileRef.current += (movedY / maxHeight * 100);

            if(scrolledPercentileRef.current < 0)
                scrolledPercentileRef.current = 0;
            else if(scrolledPercentileRef.current > 100)
                scrolledPercentileRef.current = 100;

            SetScrolledPercentile(scrolledPercentileRef.current);

            previousCursorPosRef.current = new CursorPosition(e.clientX, e.clientY);
        }
    });
    const OnMouseUpRef = useRef<any>(() => {
        previousCursorPosRef.current = null;
    });

    //watchers
    //test
    // useEffect(() => {
    //     dlog('ScrollBarTest: ' + scrolledPercentile);
    // }, [scrolledPercentile]);

    //initialize
    useEffect(() => {
        // start update scroll percentile animation frame
        if (updateScrollPercentileAnimRef.current == null)
            updateScrollPercentileAnimRef.current = UpdateScrollPercentileAnim();

        // add event listeners
        window.addEventListener('mousemove', OnMouseMoveRef.current);
        window.addEventListener('mouseup', OnMouseUpRef.current);

        return (() => {
            if (updateScrollPercentileAnimRef.current)
                cancelAnimationFrame(updateScrollPercentileAnimRef.current);

            window.removeEventListener('mousemove', OnMouseMoveRef.current);
            window.removeEventListener('mouseup', OnMouseUpRef.current);
        });
    }, []);

    //watch for scroll percentile update scrollTarget
    useEffect(() => {
        //cursor is dragged
        if(previousCursorPosRef.current) {
            targetRef.current.scrollTop = (targetRef.current.scrollHeight - targetRef.current.clientHeight) * scrolledPercentile / 100;
        }
    }, [scrolledPercentile]);

    //ui functions
    const OnMouseDown = (e: any) => {
        previousCursorPosRef.current = new CursorPosition(e.clientX, e.clientY);
    }

    //exe functions
    const UpdateScrollPercentileAnim = () => {
        if (previousCursorPosRef.current == null && targetRef.current) {
            scrolledPercentileRef.current = targetRef.current.scrollTop / (targetRef.current.scrollHeight - targetRef.current.clientHeight) * 100;
            SetScrolledPercentile(scrolledPercentileRef.current);
        }

        updateScrollPercentileAnimRef.current = requestAnimationFrame(() => {
            UpdateScrollPercentileAnim();
        });
    }

    return (
        <div className={'ScrollBar ' + (className ? className : '')}>
            <div className='ScrollBar-cursor-space' ref={cursorSpaceRef}>
                <div
                    className='ScrollBar-cursor'
                    onMouseDown={OnMouseDown}
                    style={{ top: `${scrolledPercentile}%` }}
                />
            </div>
        </div>
    )
}
export default ScrollBar;